// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main_3ACoB","header":"index_header_3-BVK"};